const BASE = {
  bg:          '#FFF0F5',
  bgCard:      '#FFFFFF',
  bgHover:     '#FDF2F8',
  border:      '#FBCFE8',
  accent:      '#EC4899',
  accentLight: '#FCE7F3',
  primary:     'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
  primaryHover:'linear-gradient(135deg, #DB2777 0%, #EC4899 100%)',
  text:        '#581C47',
  muted:       '#BE84A3',
  success:     '#34D399',
  danger:      '#F87171',
  gradient:    'linear-gradient(160deg, #FFF0F5 0%, #FFE4EF 60%, #FDF2F8 100%)',
  gradientCard:'linear-gradient(135deg, #FFFFFF 0%, #FDF2F8 100%)',
  btnGrad:     'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
};

export const TEMAS = {
  militar: {
    ...BASE,
    niveles:   ['SLP 1', 'SLP 2', 'SLP 3', 'SLP 4', 'Acceso Suboficial', 'Acceso Oficial', 'Curso Suboficial', 'Curso Oficial'],
    nivelesId: ['SLP1', 'SLP2', 'SLP3', 'SLP4', 'ACCESO_SUBOFICIAL', 'ACCESO_OFICIAL', 'CURSO_SUBOFICIAL', 'CURSO_OFICIAL'],
    nombre:    'Programa Militar',
    etiqueta:  'SLP',
    icono:     '🎖️',
  },
  civil: {
    ...BASE,
    niveles:   ['B1', 'B2', 'C1', 'C2'],
    nivelesId: ['B1', 'B2', 'C1', 'C2'],
    nombre:    'Inglés Civil',
    etiqueta:  'Cambridge',
    icono:     '🎓',
  },
};

export const getTema = (tipo) => TEMAS[tipo] || TEMAS.civil;
